import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import dayjs from 'dayjs';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
    .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// new usage
i18n.services.formatter?.add('DATE_HUGE', (value, lng, options) => {
  return dayjs(value).locale(lng ?? 'en').format()
});

export default i18n;